(function (root, factory) {
  'use strict';
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root) { root.EnigmaSealedPriceGuard = api; if (root.document) api.boot(root); }
})(typeof window !== 'undefined' ? window : null, function () {
  'use strict';
  var CONTRACT = 'script[data-enigma-sealed-price-guard]';
  var ADD = '[data-add-to-cart], [data-btn-addToCart], .product-form__cart-submit, button[name="add"]';
  var records = new WeakMap();

  function read(form) {
    if (!form || !form.querySelector) return null;
    var node = form.querySelector(CONTRACT);
    if (!node || node.closest('form') !== form) return null;
    var record = records.get(form);
    var source = node.textContent;
    if (record && record.source === source) return record;
    var data;
    try { data = JSON.parse(source); } catch (_) { data = {variants: []}; }
    record = {source: source, data: data, blocked: false};
    records.set(form, record);
    return record;
  }

  function currentId(form) {
    var input = form.querySelector('[data-variant-id-input][name="id"]')
      || form.querySelector('input.current_variant_id[name="id"]')
      || form.querySelector('input[name="id"]') || form.querySelector('select[name="id"]');
    return String(input && input.value || '');
  }

  function decision(data, id) {
    if (!data) return {scoped: false, blocked: false, variant: null};
    var variant = (Array.isArray(data.variants) ? data.variants : []).find(function (v) { return String(v.id) === String(id); });
    var price = variant && variant.price;
    var positive = price !== null && price !== '' && Number.isFinite(Number(price)) && Number(price) > 0;
    return {scoped: true, blocked: !variant || !positive, variant: variant || null};
  }

  function inspect(form, variant) {
    var record = read(form);
    return decision(record && record.data, variant ? variant.id : currentId(form));
  }
  function isBlocked(form, variant) { return inspect(form, variant).blocked; }
  // A sealed form has an explicit per-variant label contract; inventory policy alone is not a preorder.
  function preorderState(form, variant) {
    var record = read(form);
    var id = variant ? variant.id : form && form.querySelector ? currentId(form) : '';
    var result = decision(record && record.data, id);
    if (record && !result.scoped) return false;
    if (!result.scoped && form && form.querySelector) {
      var node = form.querySelector('script[data-enigma-explicit-preorder]');
      if (node && node.closest('form') === form) {
        var data;
        try { data = JSON.parse(node.textContent); } catch (_) { return false; }
        if (!data || typeof data !== 'object') return false;
        result = decision(data, id);
      }
    }
    if (!result.scoped) return null;
    return !result.blocked && result.variant.available === true && result.variant.preorder === true;
  }
  function label(form) { var record = read(form); return record && record.data.label || 'Prezzo da confermare'; }
  function attr(node, name, value) {
    if (!node) return;
    var next = value == null ? null : String(value);
    if (node.getAttribute(name) === next) return;
    if (next === null) node.removeAttribute(name); else node.setAttribute(name, next);
  }
  function text(node, value) { if (node && node.textContent !== value) node.textContent = value; }
  function bool(node, name, value) { if (node && node[name] !== value) node[name] = value; }
  function scopeOf(form) {
    return form.closest('.item-product, .enigma-home-product-card, .product-single__stick-add, .product-single__information')
      || form.closest('.product-template__container') || form;
  }

  function sync(form) {
    var record = read(form);
    if (!record) return false;
    var result = inspect(form);
    var blocked = result.blocked;
    var scope = scopeOf(form);
    var message = label(form);
    attr(form, 'data-enigma-price-blocked', blocked ? 'true' : null);
    if (blocked) {
      attr(form, 'data-product-purchasable', 'false');
      attr(form, 'data-product-state', 'price-unavailable');
    } else if (record.blocked && form.getAttribute('data-product-state') === 'price-unavailable') {
      attr(form, 'data-product-purchasable', String(result.variant.available === true));
      attr(form, 'data-product-state', result.variant.available === true ? 'available' : 'sold-out');
    }
    Array.prototype.forEach.call(form.querySelectorAll(ADD), function (button) {
      if (blocked) {
        attr(button, 'data-enigma-price-disabled', 'true');
        bool(button, 'disabled', true); attr(button, 'aria-disabled', 'true');
      } else if (button.hasAttribute('data-enigma-price-disabled')) {
        attr(button, 'data-enigma-price-disabled', null);
        var purchasable = result.variant.available === true && form.getAttribute('data-product-purchasable') !== 'false';
        bool(button, 'disabled', !purchasable); attr(button, 'aria-disabled', String(!purchasable));
      }
      var buttonText = button.querySelector('[data-add-to-cart-text], .add-to-cart-text, [id^="AddToCartText"]');
      if (blocked) text(buttonText, message);
      else if (record.blocked && buttonText && buttonText.textContent === message) text(buttonText, result.variant.available === true ? result.variant.addLabel : (record.data.soldOutLabel || 'Esaurito'));
      Array.prototype.forEach.call(button.querySelectorAll('.add-to-cart-price'), function (price) { bool(price, 'hidden', blocked); });
    });
    Array.prototype.forEach.call(form.querySelectorAll('input[name="id"], input[name="quantity"]'), function (input) {
      if (blocked) { attr(input, 'data-enigma-price-disabled', 'true'); bool(input, 'disabled', true); }
      else if (input.hasAttribute('data-enigma-price-disabled')) { attr(input, 'data-enigma-price-disabled', null); bool(input, 'disabled', result.variant.available !== true); }
    });
    // Direct cards also render a hidden fallback swatch form. It must not own the shared price.
    if (!form.closest('.item-product-popup.hide')) {
      Array.prototype.forEach.call(scope.querySelectorAll('[data-enigma-price-pending]'), function (pending) {
        bool(pending, 'hidden', !blocked); text(pending, message);
      });
      Array.prototype.forEach.call(scope.querySelectorAll('[data-enigma-priced]'), function (priced) { bool(priced, 'hidden', blocked); });
    }
    Array.prototype.forEach.call(form.querySelectorAll('[data-enigma-availability-trigger]'), function (request) {
      var canRequest = !!result.variant && (blocked || (!request.hasAttribute('data-enigma-price-request') && result.variant.available !== true));
      bool(request, 'hidden', !canRequest); bool(request, 'disabled', !canRequest); attr(request, 'aria-hidden', String(!canRequest));
      attr(request, 'data-availability-variant-id', result.variant ? result.variant.id : '');
    });
    Array.prototype.forEach.call(form.querySelectorAll('[data-product-payment], [data-enigma-price-payment]'), function (payment) {
      if (blocked) { attr(payment, 'data-enigma-price-hidden', 'true'); bool(payment, 'hidden', true); attr(payment, 'aria-hidden', 'true'); attr(payment, 'inert', ''); }
      else if (payment.hasAttribute('data-enigma-price-hidden')) { attr(payment, 'data-enigma-price-hidden', null); bool(payment, 'hidden', result.variant.available !== true); attr(payment, 'aria-hidden', String(payment.hidden)); attr(payment, 'inert', payment.hidden ? '' : null); }
    });
    record.blocked = blocked;
    return blocked;
  }

  function boot(win) {
    if (!win.document || win.__enigmaSealedPriceGuardReady) return;
    win.__enigmaSealedPriceGuardReady = true;
    var doc = win.document;
    var registered = new WeakSet();
    function install(form) {
      if (!form || !read(form)) return;
      if (!registered.has(form)) {
        registered.add(form);
        var submit = form.submit;
        if (typeof submit === 'function') form.submit = function () { if (isBlocked(this)) { sync(this); return false; } return submit.apply(this, arguments); };
        var requestSubmit = form.requestSubmit;
        if (typeof requestSubmit === 'function') form.requestSubmit = function () { if (isBlocked(this)) { sync(this); return false; } return requestSubmit.apply(this, arguments); };
      }
      sync(form);
    }
    function scan(node) {
      if (!node || !node.querySelectorAll) return;
      if (node.matches && node.matches(CONTRACT)) install(node.closest('form'));
      Array.prototype.forEach.call(node.querySelectorAll(CONTRACT), function (script) { install(script.closest('form')); });
      var form = node.closest && node.closest('form');
      if (form) install(form);
    }
    function block(event) {
      var target = event.target;
      var button = event.type === 'click' && target.closest && target.closest(ADD);
      var form = event.type === 'submit' ? target : button && button.closest('form');
      if (!form || !isBlocked(form)) return;
      sync(form); event.preventDefault(); event.stopImmediatePropagation();
    }
    doc.addEventListener('click', block, true);
    doc.addEventListener('submit', block, true);
    doc.addEventListener('change', function (event) { var form = event.target.closest && event.target.closest('form'); if (form) { sync(form); Promise.resolve().then(function () { sync(form); }); } });
    if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', function () { scan(doc); }, {once:true}); else scan(doc);
    if (win.MutationObserver) new win.MutationObserver(function (mutations) {
      var forms = new Set();
      mutations.forEach(function (mutation) {
        Array.prototype.forEach.call(mutation.addedNodes || [], scan);
        var form = mutation.target.closest && mutation.target.closest('form');
        if (form && read(form)) forms.add(form);
      });
      forms.forEach(install);
    }).observe(doc.documentElement, {childList:true,subtree:true,attributes:true,attributeFilter:['value','disabled','aria-disabled','data-product-state','data-product-purchasable']});
  }
  return {decision:decision,isBlocked:isBlocked,preorderState:preorderState,label:label,sync:sync,boot:boot};
});
